export const attendanceStatisticsRouting = [
  {
    path: "/attendance/statistics/list",
    name: "attendance-statistics-list",
    meta: { title: "考勤统计" },
    component: () =>
      import(/* webpackChunkName: "attendance-leave" */ "@/views/attendance-management/attendance-statistics/list/list.vue"),
  },
	// {
	// 	hidden:true,
	//   path: "/attendance/leave/create",
	//   name: "attendance-leave-create",
	//   meta: { title: "新建请假申请" },
	//   component: () =>
	//     import(/* webpackChunkName: "attendance-leave" */ "@/views/attendance-management/leave-application/form/form.vue"),
	// },
	// {
	// 	hidden:true,
	//   path: "/attendance/leave/edit/:id",
	//   name: "attendance-leave-edit",
	//   meta: { title: "编辑请假申请" },
	//   component: () =>
	//     import(/* webpackChunkName: "attendance-leave" */ "@/views/attendance-management/leave-application/form/form.vue"),
	// },
	// {
	// 	hidden:true,
	//   path: "/attendance/leave/detail/:id",
	//   name: "attendance-leave-detail",
	//   meta: { title: "请假申请详情" },
	//   component: () =>
	//     import(/* webpackChunkName: "attendance-leave" */ "@/views/attendance-management/leave-application/detail/detail.vue"),
	// },
]